<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; {{currentDate | date: 'yyyy'}} <a id="pixinventLink"
      href="https://entim.pl">ENTIM</a>
    <span class="d-none d-sm-inline-block">, Wszystkie prawa zastrzeżone.</span>
  </p>
</footer>
<!--Footer Ends-->
